/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

import getAlign from './utilities/_align.css';
import getBackground from './utilities/_background.css';
import getBorders from './utilities/_borders.css';
import getClearfix from './utilities/_clearfix.css';
import getDisplay from './utilities/_display.css';
import getEmbed from './utilities/_embed.css';
import getFlex from './utilities/_flex.css';
import getFloat from './utilities/_float.css';
import getInteractions from './utilities/_interactions.css';
import getOverflow from './utilities/_overflow.css';
import getPosition from './utilities/_position.css';
import getScreenreaders from './utilities/_screenreaders.css';
import getShadows from './utilities/_shadows.css';
import getSizing from './utilities/_sizing.css';
import getSpacing from './utilities/_spacing.css';
import getStretchedLink from './utilities/_stretched-link.css';
import getText from './utilities/_text.css';
// import getVisibility from './utilities/_visibility.css';

const styles = [
  getAlign,
  getBackground,
  getBorders,
  getClearfix,
  getDisplay,
  getEmbed,
  getFlex,
  getFloat,
  getInteractions,
  getOverflow,
  getPosition,
  getScreenreaders,
  getShadows,
  getSizing,
  getSpacing,
  getStretchedLink,
  getText,
  // getVisibility,
];

export default $ => css(styles.map(style => style($)));
